/**
 * Returns true/false if a gate is open, or null if the signal is unbound.
 *
 * @param {object}       liveValues  - node.data.liveValues dict
 * @param {string}       signalKey   - primary signal key (open sensor, e.g. "gate_1", "outlet_state")
 * @param {string}       closeKey    - secondary signal key used in dual mode (e.g. "gate_1_close") — accepted for clarity, not used for state computation
 * @param {'single'|'dual'} sensorType - "single": one sensor; "dual": open + close sensors
 * @param {'high'|'low'} openLevel   - for single mode only: "high" = val >= threshold means open; "low" = inverted
 * @param {number}       threshold   - numeric threshold from config.threshold
 * @returns {boolean|null}           - null means unbound (caller should hide indicator)
 */
export function isGateOpen(liveValues, signalKey, closeKey, sensorType, openLevel, threshold) {
    const rawVal = liveValues?.[signalKey];
    if (rawVal == null) return null;
    const val = parseFloat(rawVal);
    if (isNaN(val)) return null;
    if (sensorType === 'dual') return val >= threshold;
    return openLevel === 'low' ? val < threshold : val >= threshold;
}
